export default __webpack_public_path__ + "static/media/Group 3218@2x.8c2c3334.png";